module.exports = __webpack_public_path__ + "static/media/search.cf3eea68.svg";